import React from "react";
import { Route, Link, Routes, Navigate } from "react-router-dom";
// import Home from "./pages/Home";
import Home from "./pages/index";
import SearchResultPage from "./pages/searchnoresult/index";
import Login from "./pages/Login/Login";
import Superadmin from "./pages/Superadmin/Superadmin";
import Password_recovery from "./pages/password-recovery/Password_recovery";
import Password_reset from "./pages/password-reset/Password_reset";
import EditorDashboard from "./pages/user/EditorDashboard/EditorDashboard";
import ManagerDashboard from "./pages/user/ManagerDashboard/ManagerDashboard";
import EditorAccount from "./pages/user/EditorDashboard/EditorAccount";
import Myaccount from "./pages/Myaccount/Myaccount";
import EditorMessage from "./pages/user/EditorDashboard/EditorMessage";
import MyAccountManager from "./pages/user/ManagerDashboard/MyAccount";
import EditorPublishVideo from "./pages/user/EditorDashboard/EditorPublishVideo";
import EditorMessageVideo from "./pages/user/EditorDashboard/EditorMessageVideo";
import EditorPublishVideoPage from "./pages/user/EditorDashboard/EditorPublishVideoPage";
import MyMessage from "./pages/user/ManagerDashboard/MyMessage/MyMessage";
import Support from "./pages/user/ManagerDashboard/MyMessage/Support";
import ReviewedVideos from "./pages/user/ManagerDashboard/ReviewdVideosApproved/ReviewedVideos";
import ManagerNotification from "./pages/user/ManagerDashboard/ManagerNotification";
import EditorNotification from "./pages/user/EditorDashboard/EditorNotification";
import Pending from "./pages/user/ManagerDashboard/SubmittedVideos/Pending";
import VideoPending from "./pages/user/ManagerDashboard/SubmittedVideos/VideoPending";
import EditorSupport from "./pages/user/EditorDashboard/EditorSupport";
import EditorSupportTicket from "./pages/user/EditorDashboard/EditorSupportTicket";
import ReviewedVideosWebsite from "./pages/user/ManagerDashboard/ReviewdVideosWebsite/ReviewdVideosWebsite";
import ReviewdVideoRejected from "./pages/user/ManagerDashboard/ReviewdVideosRejected/ReviewdVideoRejected";
import EditorSearchResult from "./pages/user/EditorDashboard/EditorSearchResult";
import VerifiedVideoConfirmed from "./pages/user/ManagerDashboard/VerifiedVideoConfirmed/VerifiedVideoConfirmed";
import EditorPendingPublication from "./pages/user/EditorDashboard/EditorPendingPublication";
import MemberPartnerDashboard from "./pages/user/MemberPartnerDashboard/MemberPartnerDashboard";
import EditorPendingPublicationVideoPage from "./pages/user/EditorDashboard/EditorPendingPublicationVideoPage";
import PartnerSearchResult from "./pages/user/MemberPartnerDashboard/SearchResult";
import MemberPartnerAccount from "./pages/user/MemberPartnerDashboard/MemberPartnerAccount";
import VerifiedVideoDenied from "./pages/user/ManagerDashboard/VerifiedVideoDenied/VerifiedVideoDenied";
import Approved from "./pages/user/QcagentDashboard/AwaitingConfirmation/Approved";
import MyVideosApproved from "./pages/user/MemberPartnerDashboard/MyVideosDashboard";
import VideoPage from "./pages/user/QcagentDashboard/AwaitingConfirmation/VideoPage";
// import MyVideosApproved from "./pages/user/MemberPartnerDashboard/MyVideosApproved";
import Resetpassword from "./pages/resetpassword/Resetpassword";
import Analytics from "./pages/analytics/Analytics";
import {
  PrivateRoute,
  PrivateRoutes,
  QCdashboad,
  contentbuyerdashboad,
  copywritersdashboad,
  editordashboad,
  managerdashboad,
  memberpartnerdashboad,
} from "./PrivateRoute";
import { useAppDispatch } from "./hooks/useAppDispatch";
import { fetchAcquisitors } from "./api/functions/acquisitor.api";
import { fetchInquirer } from "./api/functions/inquirer.api";
import { fetchManagers } from "./api/functions/manager.api";
import { qcSubmissionsList, submissionsList } from "./api/functions/cms.api";
// import { setAcquisitors, setInquirers, setManagers, setSubmission, setQualityTeam, } from "./redux-toolkit/slices/app.state.slice";
import {
  setAcquisitors,
  setInquirers,
  setManagers,
  setSubmission,
  setQualityTeam,
  setContentBuyers,
  setCompanies,
  setQcSubmission,
} from "./redux-toolkit/slices/app.state.slice";
import { useQuery } from "react-query";
import { parseCookies } from "nookies";
import CopywriterDashboard from "./pages/user/CopywriterDashboard/CopywriterDashboard";
import { fetchQualityTeam } from "./api/functions/quality.team.api";
import MemberPartnerAnalytics from "./pages/user/MemberPartnerDashboard/MemberPartnerAnalytics";
import PartnerMessage from "./pages/user/MemberPartnerDashboard/PartnerMessage";
import PartnerMessageVideo from "./pages/user/MemberPartnerDashboard/PartnerMessageVideo";
import PartnerSupport from "./pages/user/MemberPartnerDashboard/PartnerSupport";
import PartnerSupportTicket from "./pages/user/MemberPartnerDashboard/PartnerSupportTicket";
import PartnerNotification from "./pages/user/MemberPartnerDashboard/MemberPartnerNotification";
import QcagentDasboard from "./pages/user/QcagentDashboard/QcagentDasboard";
import MyVideoApprovedVideoPage from "./pages/user/MemberPartnerDashboard/MyVideoDashboardVideoPage/MyVideoApprovedVideoPage";
import { WebsiteOnly } from "./pages/user/QcagentDashboard/AwaitingConfirmation/WebsiteOnly";
import { WebsiteOnlyVideoPage } from "./pages/user/QcagentDashboard/AwaitingConfirmation/WebsiteOnlyVideoPage";
import QcAccount from "./pages/user/QcagentDashboard/QcAccount";
import MemberPartnerPendingVideoPage from "./pages/user/MemberPartnerDashboard/MyVideoDashboardVideoPage/MyVideoPendingVideoPage";
import MemberPartnerRejectedVideoDetailsPreview from "./pages/user/MemberPartnerDashboard/MyVideoDashboardVideoPage/MyVideoRejectedVideoPage";
import MemberPartnerDuplicateVideoDetailsPreview from "./pages/user/MemberPartnerDashboard/MyVideoDashboardVideoPage/MyVideoDuplicateVideoPage";
import QcMessage from "./pages/user/QcagentDashboard/QcMessage";
import QcMessageVideo from "./pages/user/QcagentDashboard/QcMessageVideo";
import QcSupport from "./pages/user/QcagentDashboard/QcSupport";
import QcSupportTicket from "./pages/user/QcagentDashboard/QcSupportTicket";
import Rejected from "./pages/SubmitedVideos/rejected";
import { QCRejected } from "./pages/user/QcagentDashboard/AwaitingConfirmation/QcRejected";
import { RejectedVideoPage } from "./pages/user/QcagentDashboard/AwaitingConfirmation/RejectedVideoPage";
import QcagentReviewedVideosRejected from "./pages/user/QcagentDashboard/QcReviewedVideosRejected/QcagentReviewedVideosRejected";
import { QcagentReviewedRejectedVideos } from "./pages/user/QcagentDashboard/QcReviewedVideosRejected/QcagentReviewedRejectedVideos";
import QcVerifiedVideosConfirmed from "./pages/user/QcagentDashboard/QcVerifiedVideosConfirmed/QcVerifiedVideosConfirmed";
import QcVerifiedVideosDenied from "./pages/user/QcagentDashboard/QcVerifiedVideosDenied/QcVerifiedVideosDenied";
import { QcReviewedVideosApproved } from "./pages/user/QcagentDashboard/QcReviewedVideosApproved/QcReviewedVideosApproved";
import CopywriterCompleteVideos from "./pages/user/CopywriterDashboard/complete-videos/CopywriterCompleteVideos";
import Inquiring from "./pages/user/ManagerDashboard/SubmittedVideos/Inquiring";
import VideoInquiring from "./pages/user/ManagerDashboard/SubmittedVideos/VideoInquiring";

import Duplications from "./pages/user/ManagerDashboard/SubmittedVideos/Duplications";
import VideoDuplications from "./pages/user/ManagerDashboard/SubmittedVideos/VideoDuplications";
import QcSubmittedVideosDuplicates from "./pages/user/QcagentDashboard/QcSubmittedVideosDuplicates/QcSubmittedVideosDuplicates";
import QcReviewedVideosWebsiteOnly from "./pages/user/QcagentDashboard/QcReviewedVideosWebsiteOnly/QcReviewedVideosWebsiteOnly";
import QcSubmittedVideosInquiring from "./pages/user/QcagentDashboard/QcSubmittedVideosInquiring/QcSubmittedVideosInquiring";
import SearchResult from "./pages/user/ManagerDashboard/SearchResult";
import QcSearchResult from "./pages/user/QcagentDashboard/QcSearchResult";
import AssignedAccounts from "./pages/user/ManagerDashboard/AssignedAccounts";
import CopyWriterCompletedVideoDetails from "./pages/user/CopywriterDashboard/complete-videos/CopywriterCompleteVideoDetails";
import CopyWriterMyAccount from "./pages/user/CopywriterDashboard/CopyWriterMyAccount";
import PendingTitlingRevised from "./pages/user/CopywriterDashboard/pending-titling/pending-titling-revised";
import PendingTitleRevisedVideoDeatails from "./pages/user/CopywriterDashboard/pending-titling/pendingtitle-revised-video";
import ContentBuyerDashboard from "./pages/user/content-buyer/ContentBuyerDashboard";
import Accounting from "./pages/user/content-buyer/accounting/Accounting";
import ContentBuyerMessage from "./pages/user/content-buyer/message/contentbuyer-message-details/ContentBuyerMessage";
import Message from "./pages/user/content-buyer/message/Message";
import ContentbuyerSupport from "./pages/user/content-buyer/message/ContentbuyerSupport";
import Notification from "./pages/user/content-buyer/notification/Notification";
import PurchaseRequest from "./pages/user/content-buyer/purchase-requests/PurchaseRequest";
import PurchaseRequestDetails from "./pages/user/content-buyer/purchase-requests/request-details/PurchaseRequestDetails";
import PurchaseVideos from "./pages/user/content-buyer/purchased-videos/PurchaseVideos";
import VideoType from "./pages/user/content-buyer/purchased-videos/video-type/VideoType";
import QcNotification from "./pages/user/QcagentDashboard/QcNotification";
import CopyWriterMessage from "./pages/user/CopywriterDashboard/CopyWriterMessege";
import CopyWriterMessageVideo from "./pages/user/CopywriterDashboard/CopyWriterMessageVideo";
import CopyWriterSupport from "./pages/user/CopywriterDashboard/CopyWriterSupport";
import CopyWriterSupportTicket from "./pages/user/CopywriterDashboard/CopywriterSupportTicket";
import CopywriterNotification from "./pages/user/CopywriterDashboard/CopywriterNotification";
import CopywriterSearchResult from "./pages/user/CopywriterDashboard/CopywriterSearchResult";
import ContentBuyerSupportDetails from "./pages/user/content-buyer/message/contentbuyer-support-details/ContentBuyerSupportDetails";
import { QcReviewedApprovedVideospage } from "./pages/user/QcagentDashboard/QcReviewedVideosApproved/ QcReviewedApprovedVideospage";
import { QcReviewedWebsiteVCideopage } from "./pages/user/QcagentDashboard/QcReviewedVideosWebsiteOnly/QcReviewedWebsiteVCideopage";
import MessageDetails from "./pages/user/ManagerDashboard/MyMessage/MessageDetails";
import { QcSubmittedDuplicateVideopage } from "./pages/user/QcagentDashboard/QcSubmittedVideosDuplicates/QcSubmittedDuplicateVideopage";
import { QcSubmittedInquiringVideoPage } from "./pages/user/QcagentDashboard/QcSubmittedVideosInquiring/QcSubmittedInquiringVideoPage";
import { QcVerifiedConfirmedVideoPage } from "./pages/user/QcagentDashboard/QcVerifiedVideosConfirmed/QcVerifiedConfirmedVideoPage";
import { QcVerifiedDeniedVideoPage } from "./pages/user/QcagentDashboard/QcVerifiedVideosDenied/QcVerifiedDeniedVideoPage";
import ContentbuyerSearchResult from "./pages/user/content-buyer/search-result/ContentbuyerSearchResult";
import { QcSubmittedPendingVideoPage } from "./pages/user/QcagentDashboard/QcSubmittedVideoPending/QcSubmittedPendingVideoPage";
import ContentBuyerMyAccount from "./pages/user/content-buyer/my-account/ContentBuyerMyAccount";
import QcSubmittedVideosPending from "./pages/user/QcagentDashboard/QcSubmittedVideoPending/QcSubmittedPendingVideo";
import PendingTitling from "./pages/user/CopywriterDashboard/pending-titling/PendingTitling";
import PendingTitlingPage from "./pages/user/CopywriterDashboard/pending-titling/pendingTitlingPage";
import { fetchContentBuyers } from "./api/functions/contentBuyer";
import Calender from "./pages/Calender";
import { getCompanies } from "./api/functions/company.api";

import Page404 from "./pages/404";
import { useAppSelector } from "./hooks/useAppSelector";
import QcSearchVideoPage from "./pages/QcSearch/QcSearchVideoPage";
// import Submit from "./pages/SubmitedVideos/Submit";

const App = () => {
  const dispatch = useAppDispatch();
  const cookies = parseCookies();
  // const token1 = cookies?.token

  const token = cookies?.token;
  const savedrole_Id = cookies?.role_id;
  const enabled = token ? true : false;
  // console.warn("token", token);
  // console.warn("enabled", enabled);

  const {
    acquisitors,
    inquirers,
    managers,
    submission,
    qualityTeam,
    contentBuyers,
    companies,
  } = useAppSelector((s) => s.appStateSlice);

  // console.warn("savedrole_Id", savedrole_Id);

  // console.warn("acquisitors", acquisitors);
  // console.warn("managers", managers);

  const { isLoading: al } = useQuery(
    ["acquisitor", enabled, acquisitors],
    () => fetchAcquisitors(),
    {
      // Using the onSuccess callback
      onSuccess: (data) => {
        // console.warn("Data fetched successfully:", data);
        dispatch(setAcquisitors(data));
        // You can perform additional actions here with the fetched data
      },
      enabled: enabled && !acquisitors,
    }
  );
  const { isLoading: il } = useQuery(
    ["inquirer", enabled],
    () => fetchInquirer(),
    {
      // Using the onSuccess callback
      onSuccess: (data) => {
        // console.warn("Data fetched successfully:", data);
        dispatch(setInquirers(data));
        // You can perform additional actions here with the fetched data
      },
      enabled,
    }
  );
  const { isLoading: ml } = useQuery(
    ["managers", enabled],
    () => fetchManagers(),
    {
      // Using the onSuccess callback
      onSuccess: (data) => {
        // console.warn("managers fetched successfully:", data);
        dispatch(setManagers(data));
        // You can perform additional actions here with the fetched data
      },
      enabled,
    }
  );

  const { isLoading: sl } = useQuery(
    ["submissionsList", enabled],
    submissionsList,
    {
      onSuccess: (data) => {
        // console.warn("submissionsList", data);
        dispatch(setSubmission(data));
      },
      enabled: enabled && savedrole_Id == 1 ? true : false,
    }
  );

  // const { isLoading: qcsl } = useQuery(
  //   ["qcSubmissionsList", enabled, savedrole_Id],
  //   qcSubmissionsList,
  //   {
  //     onSuccess: (res) => {
  //       // console.warn("qcSubmissionsList", res);
  //       dispatch(setQcSubmission(res.data));
  //     },
  //     enabled: enabled && savedrole_Id == 6 ? true : false,
  //   }
  // );

  const { isLoading: qtl } = useQuery(
    ["quality_team", enabled],
    fetchQualityTeam,
    {
      onSuccess: (data) => {
        // console.warn("qtl", data);
        dispatch(setQualityTeam(data));
      },
      enabled,
    }
  );

  const { isLoading: cql } = useQuery(
    ["content_buyers", enabled],
    fetchContentBuyers,
    {
      onSuccess: (data) => {
        // console.warn("qtl", data);
        dispatch(setContentBuyers(data));
      },
      enabled,
    }
  );

  const { isLoading: compl } = useQuery(["companies", enabled], getCompanies, {
    onSuccess: (data) => {
      // console.warn("data comp", data);
      dispatch(setCompanies(data));
    },
    enabled: enabled && savedrole_Id == 1 ? true : false,
  });

  return (
    <>
      {/* {/ <Switch>  /} */}

      <Routes>
        <Route exact path="/home" element={<Home />} />
        <Route exact path="/page404" element={<Page404 />} />

        <Route exact path="/searchresult" element={<SearchResultPage />} />
        <Route exact path="/login" element={<Login />} />
        {/* <Route exact path="/" element={<Superadmin/>}/> */}

        {/* editor dashboard */}

        {PrivateRoutes?.map((item, i) => {
          return (
            <Route
              key={i}
              exact
              path={item?.route}
              caseSensitive
              element={<PrivateRoute>{item.component}</PrivateRoute>}
            />
          );
        })}

        {managerdashboad?.map((item, i) => {
          return (
            <Route
              key={i}
              exact
              path={item?.route}
              caseSensitive
              element={<PrivateRoute>{item.component}</PrivateRoute>}
            />
          );
        })}

        {editordashboad?.map((item, i) => {
          return (
            <Route
              key={i}
              exact
              path={item?.route}
              caseSensitive
              element={<PrivateRoute>{item.component}</PrivateRoute>}
            />
          );
        })}

        {copywritersdashboad?.map((item, i) => {
          return (
            <Route
              key={i}
              exact
              path={item?.route}
              caseSensitive
              element={<PrivateRoute>{item.component}</PrivateRoute>}
            />
          );
        })}

        {QCdashboad?.map((item, i) => {
          return (
            <Route
              key={i}
              exact
              path={item?.route}
              caseSensitive
              element={<PrivateRoute>{item.component}</PrivateRoute>}
            />
          );
        })}

        {contentbuyerdashboad?.map((item, i) => {
          return (
            <Route
              key={i}
              exact
              path={item?.route}
              caseSensitive
              element={<PrivateRoute>{item.component}</PrivateRoute>}
            />
          );
        })}

        {memberpartnerdashboad?.map((item, i) => {
          return (
            <Route
              key={i}
              exact
              path={item?.route}
              caseSensitive
              element={<PrivateRoute>{item.component}</PrivateRoute>}
            />
          );
        })}

        {/* {/ <Route exact path="/home" element={<Home />} /> /} */}

        {/* {/ <Route exact path="/" element={<Superadmin/>}/> /} */}
        {/* <Route exact path="/" element={<Home />} /> */}
        <Route exact path="/analytics" element={<Analytics />} />

        {/* <Route exact path="/" element={<Login />} /> */}
        {/* <Route exact path="/asdasdas" element={<Superadmin />} /> */}
        <Route
          exact
          path="/Password-recovery"
          element={<Password_recovery />}
        />
        <Route exact path="/Password-reset" element={<Password_reset />} />

        <Route exact path="/Change-Password" element={<Resetpassword />} />

        {/* // {/ Resetpassword /} */}
        {/* <Route exact path="/" element={<Superadmin />} /> */}
        {/* <Route exact path="/calender" element={<Calender />} /> */}
        {/* <Route exact path="/editor-dashboard" element={<EditorDashboard />} /> */}
        {/* <Route exact path="/manager-dashboard" element={<ManagerDashboard />} /> */}
        {/* <Route
          exact
          path="/user/copywriter"
          element={<CopywriterDashboard />}
        /> */}
        {/* <Route
          exact
          path="/content-buyer-dashboard"
          element={<ContentBuyerDashboard />}
        /> */}
        <Route
          exact
          path="/content-buyer-dashboard/accounting"
          element={<Accounting />}
        />
        <Route
          exact
          path="/content-buyer-dashboard/message"
          element={<Message />}
        />
        <Route
          exact
          path="/content-buyer-dashboard/support"
          element={<ContentbuyerSupport />}
        />
        <Route
          exact
          path="/content-buyer-dashboard/message/content-buyer-message/:id"
          element={<ContentBuyerMessage />}
        />
        <Route
          exact
          path="/content-buyer-dashboard/message/content-buyer-support/:id"
          element={<ContentBuyerSupportDetails />}
        />
        <Route
          exact
          path="/content-buyer-dashboard/notification"
          element={<Notification />}
        />
        <Route
          exact
          path="/content-buyer-dashboard/purchase-request"
          element={<PurchaseRequest />}
        />
        <Route
          exact
          path="/content-buyer-dashboard/purchase-request/purchase-request-details"
          element={<PurchaseRequestDetails />}
        />
        <Route
          exact
          path="/content-buyer-dashboard/purchase-videos"
          element={<PurchaseVideos />}
        />
        <Route
          exact
          path="/content-buyer-dashboard/purchase-videos/video-type"
          element={<VideoType />}
        />
        <Route
          exact
          path="/content-buyer-dashboard/search-result"
          element={<ContentbuyerSearchResult />}
        />
        <Route
          exact
          path="/content-buyer-dashboard/my-account"
          element={<ContentBuyerMyAccount />}
        />
        <Route
          exact
          path="/editor-dashboard/notification"
          element={<EditorNotification />}
        />
        {/* <Route
          exact
          path="/manager-dashboard/myaccount"
          element={<MyAccountManager />
        
        
        }
        /> */}

        {/* <Route
          exact
          path="/manager-dashboard/messages"
          element={<MyMessage />}
        /> */}
        <Route
          exact
          path="/manager-dashboard/messages/message-details"
          element={<MessageDetails />}
        />
        <Route
          exact
          path="/manager-dashboard/support"
          element={<Support />}
        />
        <Route
          exact
          path="/manager-dashboard/reviewd-videos"
          element={<ReviewedVideos />}
        />
        <Route
          exact
          path="/manager-dashboard/reviewd-videos-website"
          element={<ReviewedVideosWebsite />}
        />
        <Route
          exact
          path="/manager-dashboard/reviewd-videos-rejected"
          element={<ReviewdVideoRejected />}
        />
        <Route
          exact
          path="/manager-dashboard/verified-videos-confirmed"
          element={<VerifiedVideoConfirmed />}
        />
        <Route
          exact
          path="/manager-dashboard/verified-videos-denied"
          element={<VerifiedVideoDenied />}
        />
        <Route
          exact
          path="/manager-dashboard/notification"
          element={<ManagerNotification />}
        />
        <Route
          exact
          path="/manager-dashboard/submitted-videos/pending"
          element={<Pending />}
        />
        <Route
          exact
          path="/manager-dashboard/submitted-videos/inquiring"
          element={<Inquiring />}
        />
        <Route
          exact
          path="/manager-dashboard/submitted-videos/duplications"
          element={<Duplications />}
        />
        <Route
          exact
          path="/manager-dashboard/submitted-videos/pending/video"
          element={<VideoPending />}
        />
        <Route
          exact
          path="/manager-dashboard/submitted-videos/inquiring/video"
          element={<VideoInquiring />}
        />
        <Route
          exact
          path="/manager-dashboard/submitted-videos/duplications/video"
          element={<VideoDuplications />}
        />
        <Route
          exact
          path="/manager-dashboard/search-result"
          element={<SearchResult />}
        />
        <Route
          exact
          path="/manager-dashboard/assigned-accounts"
          element={<AssignedAccounts />}
        />

        <Route
          exact
          path="/editor-dashboard/editor-pending-publication"
          element={<EditorPendingPublication />}
        />
        <Route
          exact
          path="/editor-dashboard/editor-pending-publication-video"
          element={<EditorPendingPublicationVideoPage />}
        />
        <Route
          exact
          path="/editor-dashboard/editor-account"
          element={<EditorAccount />}
        />
        <Route
          exact
          path="/editor-dashboard/editor-message/messages"
          element={<EditorMessage />}
        />
        <Route
          exact
          path="/editor-dashboard/editor-message/video"
          element={<EditorMessageVideo />}
        />
        <Route
          exact
          path="/editor-dashboard/editor-publish-video"
          element={<EditorPublishVideo />}
        />
        <Route
          exact
          path="/editor-dashboard/editor-publish-video-page"
          element={<EditorPublishVideoPage />}
        />
        <Route
          exact
          path="/editor-dashboard/editor-support"
          element={<EditorSupport />}
        />
        <Route
          exact
          path="/editor-dashboard/editor-support/tickets"
          element={<EditorSupportTicket />}
        />
        <Route
          exact
          path="/editor-dashboard/editor-search"
          element={<EditorSearchResult />}
        />

        {/* manage-dashboard */}

        <Route exact path="/myaccount" element={<Myaccount />} />

        {/* member-partner dashboard */}
        {/* <Route
          exact
          path="/memberpartner-dashboard"
          element={<MemberPartnerDashboard />}
        /> */}
        <Route
          exact
          path="/memberpartner-dashboard/analytics"
          element={<MemberPartnerAnalytics />}
        />
        <Route
          exact
          path="/member-partner-dashboard/search-results"
          element={<PartnerSearchResult />}
        />
        <Route
          exact
          path="/member-partner-dashboard/my-videos-approved"
          element={<MyVideosApproved />}
        />
        <Route
          exact
          path="/member-partner-dashboard/accounts"
          element={<MemberPartnerAccount />}
        />
        <Route
          exact
          path="/member-partner-dashboard/my-videos-approved/video-page"
          element={<MyVideoApprovedVideoPage />}
        />
        <Route
          exact
          path="/member-partner-dashboard/my-videos-pending/video-page"
          element={<MemberPartnerPendingVideoPage />}
        />
        <Route
          exact
          path="/member-partner-dashboard/accounts"
          element={<MemberPartnerAccount />}
        />
        <Route
          exact
          path="/member-partner-dashboard/my-videos-rejected/video-page"
          element={<MemberPartnerRejectedVideoDetailsPreview />}
        />
        <Route
          exact
          path="/member-partner-dashboard/my-videos-duplicate/video-page"
          element={<MemberPartnerDuplicateVideoDetailsPreview />}
        />
        <Route
          exact
          path="/member-partner-dashboard/accounts"
          element={<MemberPartnerAccount />}
        />
        <Route
          exact
          path="/member-partner-dashboard/message"
          element={<PartnerMessage />}
        />
        <Route
          exact
          path="/member-partner-dashboard/message/video/:id"
          element={<PartnerMessageVideo />}
        />
        <Route
          exact
          path="/member-partner-dashboard/support"
          element={<PartnerSupport />}
        />
        <Route
          exact
          path="/member-partner-dashboard/support/ticket"
          element={<PartnerSupportTicket />}
        />
        <Route
          exact
          path="/member-partner-dashboard/notification"
          element={<PartnerNotification />}
        />
        <Route
          exact
          path="/qcagent-dashboard/awating-confirmation/approved"
          element={<Approved />}
        />
        <Route
          exact
          path="/qcagent-dashboard/awating-confirmation/approved-video"
          element={<VideoPage />}
        />
        <Route
          exact
          path="/qcagent-dashboard/awating-confirmation/website-only"
          element={<WebsiteOnly />}
        />
        <Route
          exact
          path="/qcagent-dashboard/awating-confirmation/website-only-video"
          element={<WebsiteOnlyVideoPage />}
        />
        <Route
          exact
          path="/qcagent-dashboard/awating-confirmation/rejected"
          element={<QCRejected />}
        />
        <Route
          exact
          path="/qcagent-dashboard/awating-confirmation/rejected-video"
          element={<RejectedVideoPage />}
        />

        {/* Qcagent */}
        {/* <Route exact path="/qcagent-dashboard" element={<QcagentDasboard />} /> */}
        <Route
          exact
          path="/qcagent-dashboard/qc-account"
          element={<QcAccount />}
        />
        <Route
          exact
          path="/qcagent-dashboard/qc-message"
          element={<QcMessage />}
        />
        <Route
          exact
          path="/qcagent-dashboard/qc-message/video"
          element={<QcMessageVideo />}
        />
        <Route
          exact
          path="/qcagent-dashboard/qc-support"
          element={<QcSupport />}
        />
        <Route
          exact
          path="/qcagent-dashboard/qc-support/ticket"
          element={<QcSupportTicket />}
        />
        <Route
          exact
          path="/qcagent-dashboard/reviewed-videos/rejected"
          element={<QcagentReviewedVideosRejected />}
        />
        <Route
          exact
          path="/qcagent-dashboard/reviewed-videos/rejected-videos"
          element={<QcagentReviewedRejectedVideos />}
        />
        <Route
          exact
          path="/qcagent-dashboard/reviewed-videos/website-only"
          element={<QcReviewedVideosWebsiteOnly />}
        />
        <Route
          exact
          path="/qcagent-dashboard/reviewed-videos/website-only-video"
          element={<QcReviewedWebsiteVCideopage />}
        />
        <Route
          exact
          path="/qcagent-dashboard/qc-verified-videos-confirmed"
          element={<QcVerifiedVideosConfirmed />}
        />
        <Route
          exact
          path="/qcagent-dashboard/qc-verified-videos-confirmed-videos"
          element={<QcVerifiedConfirmedVideoPage />}
        />
        <Route
          exact
          path="/qcagent-dashboard/qc-verified-videos-denied"
          element={<QcVerifiedVideosDenied />}
        />
        <Route
          exact
          path="/qcagent-dashboard/qc-verified-videos-denied-videos"
          element={<QcVerifiedDeniedVideoPage />}
        />
        <Route
          exact
          path="/qcagent-dashboard/reviewed-videos/approved"
          element={<QcReviewedVideosApproved />}
        />
        <Route
          exact
          path="/qcagent-dashboard/reviewed-videos/approved-videos"
          element={<QcReviewedApprovedVideospage />}
        />
        <Route
          exact
          path="/qcagent-dashboard/search-result"
          element={<QcSearchResult />}
        />
        <Route
          exact
          path="/qcagent-dashboard/submitted-videos/duplicated"
          element={<QcSubmittedVideosDuplicates />}
        />
        <Route
          exact
          path="/qcagent-dashboard/submitted-videos/duplicated-video"
          element={<QcSubmittedDuplicateVideopage />}
        />
        <Route
          exact
          path="/qcagent-dashboard/submitted-videos/inquiring"
          element={<QcSubmittedVideosInquiring />}
        />
        <Route
          exact
          path="/qcagent-dashboard/submitted-videos/inquiring-video"
          element={<QcSubmittedInquiringVideoPage />}
        />
        <Route
          exact
          path="/qcagent-dashboard/submitted-videos/pending"
          element={<QcSubmittedVideosPending />}
        />
        <Route
          exact
          path="/qcagent-dashboard/submitted-videos/pending-video"
          element={<QcSubmittedPendingVideoPage />}
        />
        <Route
          exact
          path="/qcagent-dashboard/notification"
          element={<QcNotification />}
        />

        {/* Copy Writer Dashboard routes */}
        <Route
          exact
          path="/copywriter-dashboard/completed-videos"
          element={<CopywriterCompleteVideos />}
        />
        <Route
          exact
          path="/copywriter-dashboard/myaccount"
          element={<CopyWriterMyAccount />}
        />
        <Route
          exact
          path="/copywriter-dashboard/completed-video-details/:status"
          element={<CopyWriterCompletedVideoDetails />}
        />
        <Route
          exact
          path="/copywriter-dashboard/pending-titling/revised"
          element={<PendingTitlingRevised />}
        />
        <Route
          exact
          path="/copywriter-dashboard/pending-titling-page"
          element={<PendingTitlingPage />}
        />
        <Route
          exact
          path="/copywriter-dashboard/pending-titling-page-video"
          element={<PendingTitling />}
        />
        <Route
          exact
          path="/copywriter-dashboard/pending-titling/revised/video-page"
          element={<PendingTitleRevisedVideoDeatails />}
        />
        <Route
          exact
          path="/copywriter-dashboard/my-messages"
          element={<CopyWriterMessage />}
        />
        <Route
          exact
          path="/copywriter-dashboard/message-details/:id"
          element={<CopyWriterMessageVideo />}
        />
        <Route
          exact
          path="/copywriter-dashboard/support"
          element={<CopyWriterSupport />}
        />
        <Route
          exact
          path="/copywriter-dashboard/support-details/:id"
          element={<CopyWriterMessageVideo />}
        />
        <Route
          exact
          path="/copywriter-dashboard/support/ticket"
          element={<CopyWriterSupportTicket />}
        />
        <Route
          exact
          path="/copywriter-dashboard/notification"
          element={<CopywriterNotification />}
        />
        <Route
          exact
          path="/copywriter-dashboard/pending-titling"
          element={<PendingTitling />}
        />
        <Route
          exact
          path="/copywriter-dashboard/pending-titling/revised"
          element={<PendingTitlingRevised />}
        />
        <Route
          exact
          path="/copywriter-dashboard/search-result"
          element={<CopywriterSearchResult />}
        />
      </Routes>
      {/* // {/ </Switch>  /} */}
    </>
  );
};

export default App;
